import { CalendarV2SpeakerEvent } from "@/shared/models/economic-calendar-v2/CalendarV2Event";
import { ClassificationBadge } from "./presentational";

function Tag({ label }: { label: string }) {
  return (
    <span className="rounded-sm bg-gray-100 dark:bg-gray-800 px-1 py-0.5 text-[10px] font-medium text-gray-600 dark:text-gray-300">
      {label}
    </span>
  );
}

/**
 * Trailing cells for a `speaker` row: EVENT + a detail cell (available material
 * badges + source link) spanning the seven figure columns.
 */
export function SpeakerRowCells({ event }: { event: CalendarV2SpeakerEvent }) {
  return (
    <>
      <td className="px-1 whitespace-normal leading-normal min-w-[150px]">
        <p>
          <ClassificationBadge label="Speaker" />
          {event.summary}
        </p>
      </td>
      <td colSpan={7} className="px-1 whitespace-nowrap">
        <div className="flex flex-wrap items-center gap-2">
          {event.has_transcript && <Tag label="Transcript" />}
          {event.has_q_and_a && <Tag label="Q&A" />}
          {event.has_slides && <Tag label="Slides" />}
          {event.link && (
            <a
              href={event.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-squawk-blue hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              Source ↗
            </a>
          )}
          {!event.has_transcript &&
            !event.has_q_and_a &&
            !event.has_slides &&
            !event.link && (
              <span className="text-gray-400 dark:text-gray-500">—</span>
            )}
        </div>
      </td>
    </>
  );
}
